<template>
  <div class="container">
    <div class="speaker-wrap-header">
      <div class="speaker-wrap-header-head">
        <h1 class="entry-title" v-text="speakerInfo.name" />
      </div>
      <div class="speaker-wrap-header-breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" v-text="$t('route.home')" />
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'speakerBios' }" v-text="$t('route.speakerBios')" />
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-text="speakerInfo.name"></li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="speaker-wrap-main">
      <div class="d-flex flex-wrap">
        <div class="col-12 col-md-8">
          <div v-html="speakerInfo.bio" />
        </div>
        <div class="col-12 col-md-4">
          <router-link :to="{ name: 'speakerBios' }" class="back-to-list">
            <arrow-left-icon class="speaker-arrow-icon" />Back to Speaker List
          </router-link>
          <div class="img-speaker">
            <img :src="speakerInfo.thumbnail" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, find } from 'lodash'
import { mapState } from 'vuex'
import { ArrowLeftIcon } from 'vue-feather-icons'
export default {
  name: 'Speaker',
  components: {
    ArrowLeftIcon
  },
  data: () => ({
    speakerInfo: {}
  }),
  computed: {
    ...mapState({
      speakers: 'speakers',
      user: 'user'
    }),
    isLogged() {
      return this.user.isLoggedIn
    }
  },
  async created() {
    await this.doInitData()
    const { slug } = this.$route.params
    let speakerInfo = {}
    if (!isEmpty(slug) && !isEmpty((speakerInfo = find(this.speakers, speaker => speaker.slug === slug)))) {
      this.speakerInfo = speakerInfo
    }
  },
  methods: {
    isEmpty,
    async doInitData() {
      try {
        if (isEmpty(this.speakers)) {
          await this.$store.dispatch('fetchSpeakers')
        } else {
          this.$store.dispatch('hideLoader')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style lang="scss">
.speaker-wrap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-head {
    color: #2ba349;
    .entry-title {
      font-size: 52px;
      line-height: 62px;
    }
  }
  &-breadcrumbs {
    .breadcrumb {
      font-weight: 300;
      color: #adb0b6;
      font-size: 13px;
      line-height: 25px;
      text-transform: none;
      background-color: transparent;
      padding: 3px 12px 2px 12px;
      margin: 0;
      &-item {
        &.active,
        &::before {
          color: #adb0b6;
        }
      }
      a {
        color: #adb0b6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.speaker-wrap-main {
  padding: 70px 0;
  color: #787d85;
  font-weight: 300;
  h4 {
    color: #3b3f4a;
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
  }
  p {
    font-size: 14px;
    line-height: 26px;
  }
  .col-md-8 {
    padding: 0;
    padding-right: 50px;
  }
  .col-md-4 {
    padding-left: 50px;
    border-left: 1px solid rgba(173, 176, 182, 0.3);
  }
  @media (max-width: 767.98px) {
    .col-12 {
      padding: 0;
      border: none;
      &:nth-child(2) {
        margin-top: 60px;
      }
    }
  }
  .img-speaker {
    background-color: #ebebeb;
    border-radius: 50%;
    padding: 6px;
    max-width: 300px;
    margin: auto;
    img {
      border-radius: 50%;
      width: 100%;
    }
  }
  .back-to-list {
    display: block;
    margin-bottom: 10px;
    color: #787d85;
    font-size: 14px;
    line-height: 26px;
    &:hover {
      color: #2ba048;
    }
    svg {
      height: 20px;
      display: inline-block;
      vertical-align: text-top;
    }
  }
}
</style>
